import { client } from './api';
import type { AgencyConfigResponse, AgencyConfigUpdate } from './api/types.gen';

export type AgencyConfigPayload = AgencyConfigResponse;

/**
 * `throwOnError` on both calls, because the client resolves 4xx/5xx by default.
 * Without it every caller's `catch` here is dead code: a rejected save resolved
 * with `data` undefined, and the Intake Manager column editor and the Chart
 * Workflow toggle both went on to report success over it. Browser QA on #1911
 * caught exactly that — a 403 that showed as "settings updated".
 */
export async function getAgencyConfig(): Promise<AgencyConfigPayload> {
  const res = await client.get({
    url: '/agency-config',
    responseType: 'json',
    throwOnError: true,
  });
  return res.data as AgencyConfigPayload;
}

/**
 * Both fields are independently optional server-side, so a screen that edits
 * one must send only that one. Sending the whole shape from the Intake Manager
 * would reset the signature toggle that lives in Admin, and vice versa.
 */
export async function updateAgencyConfig(
  body: AgencyConfigUpdate
): Promise<AgencyConfigPayload> {
  const res = await client.put({
    url: '/agency-config',
    body,
    responseType: 'json',
    throwOnError: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data as AgencyConfigPayload;
}
